module.exports = __webpack_public_path__ + "media/1alB-a'a-za'a.4f9d9da2.mp3";